export type SelectedCountriesType = {
  code: string;
  name: string;
  data: Array<{
    code: string;
    data: {
      MarketUrl: string;
      DeviceRegistrationUrl?: string;
      BatteryUrl?: string;
    };
  }>;
};

export type AddressByIp = { countryRegion: { isoCode: string }; ipAddress: string };
